import React from 'react';
import Styles from './StoreNotFound.css';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { useScroll } from '../../../../utils/useLayout';
import { usePostEntry } from '../../api/use-post-entry';
import { getErrorData } from '../../shared/utils/error';

function StoreNotFound() {
  const { scrollToTop } = useScroll();
  const {
    simulationStep,
    setSimulationStep,
    setSimulationType,
    token,
    setToken,
    softRestartSimulation,
    showErrorStep,
  } = useSimuladorEnergiaSolarState();
  const visible = simulationStep?.id === SIMULATION_STEPS.END_JOURNEY_STORE_NOT_FOUND.id;
  const regenerateEntry = usePostEntry({ step: 'regenerate', token });

  const handleRegenerate = async (isFind = false) => {
    try {
      const data = await regenerateEntry.mutateAsync({});
      softRestartSimulation();
      setToken(data.token);
      setSimulationStep(SIMULATION_STEPS.FORM_BASIC_INFO);
      if (isFind) {
        setSimulationType('new');
      }
    } catch (error) {
      showErrorStep({ ...getErrorData(error), event: 'reset', ctx: 'api-regenerate-entry' });
    } finally {
      scrollToTop();
    }
  };

  if (!visible) return null;

  return (
    <>
      <div id="store-not-found" className="store-not-found">
        <ContainerHome24>
          <img
            className="error-icon"
            src="assets/simulador-energia-solar/jornada/ic-error.svg"
            alt=""
          />
          <h6 className="title">Loja não parceira</h6>
          <p className="description">
            A loja do seu orçamento não é um parceiro cadastrado Santander. Tente novamente
            encontrar a loja ou encontre um parceiro Santander mais próximo e continue sua
            simulação.
          </p>

          <Button
            variant="white"
            onClick={(ev) => {
              ev.preventDefault();

              handleRegenerate();
            }}
          >
            Tentar novamente
          </Button>
          <Button
            variant="red"
            onClick={(ev) => {
              ev.preventDefault();

              handleRegenerate(true);
            }}
          >
            Encontrar parceiro
          </Button>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default StoreNotFound;
